<script>
    import { location } from "svelte-spa-router";

    import {
        goToURL,
        resetPreventRedirectProperty,
    } from "../../../Utils/utilFunctions.svelte";

    import { getContext } from "svelte/internal";

    import {
        isMobile,
        preventRedirect,
        preventRedirectObj,
    } from "../../../stores";

    import { v4 } from "uuid";

    import {
        createSidebarTooltip,
        removeSidebarTooltip,
    } from "./helper/sidebarHelper.svelte";

    export let route;
    export let title;
    export let iFont = "";
    export let sidebarExpanded;
    export let isSoon = false;
    export let isShow = true;

    const stateContext = getContext("sidebarState");

    $: mainRoute = $location.toString().split("/")[1];

    let uuid;

    const redirectTo = () => {
        if ($isMobile) {
            stateContext.collapseSidebar();
        }

        if (!$preventRedirect) goToURL(`/${route}`);
        else {
            $preventRedirectObj.showModal = true;
            $preventRedirectObj.btnOptions = $preventRedirectObj.btnOptions.map(
                (option) => {
                    if (!option.hasBreakPoint)
                        return {
                            ...option,
                            function: async () => {
                                if (option.ignoreFunction) goToURL(`/${route}`);
                                else
                                    await option.function(goToURL(`/${route}`));

                                resetPreventRedirectProperty();
                            },
                        };
                    else
                        return {
                            ...option,
                            function: async () => {
                                if (option.ignoreFunction) {
                                    goToURL(`/${route}`);
                                    resetPreventRedirectProperty();
                                } else {
                                    const cacheBreakPoint =
                                        await option.function();
                                    if (!cacheBreakPoint) {
                                        goToURL(`/${route}`);
                                        resetPreventRedirectProperty();
                                    } else {
                                        $preventRedirectObj.showModal = false;
                                    }
                                }
                            },
                        };
                },
            );
        }
    };

    const handleMouseEnter = (e) => {
        if (sidebarExpanded) return;

        const { target } = e;

        if (!target) return;

        const targetRect = target.getBoundingClientRect();

        uuid = v4();

        const position = {
            top: targetRect.top,
            right: targetRect.right,
            bottom: targetRect.bottom,
        };

        createSidebarTooltip(position, uuid, title);
    };

    const handleMouseLeave = () => removeSidebarTooltip(uuid);
</script>

<li class={`w-full ${sidebarExpanded ? "mr-4" : ""}`}>
    {#if isSoon}
        <div
            class={`display flex justify-between w-full ${
                mainRoute === route ? "selected text-[#6F726C] " : ""
            }`}
            {...$$restProps}
        >
            <div class="flex items-center gap-x-2 pt-4 w-full">
                <slot />
                <i
                    class={mainRoute === route
                        ? `${iFont} text-white`
                        : `${iFont} text-[#6F726C]`}
                    style="font-size:18px"
                />
                {#if sidebarExpanded}
                    <p
                        class={mainRoute === route
                            ? `text-white`
                            : `text-[#6F726C]`}
                    >
                        {title}
                    </p>
                {/if}
            </div>
            {#if sidebarExpanded}
                <div
                    class="bg-[#6F726C] text-white rounded-2xl px-1 text-sm w-12 text-center"
                >
                    {isSoon ? "Soon" : ""}
                </div>
            {/if}
        </div>
    {:else if isShow}
        <div
            on:click|preventDefault={redirectTo}
            class={mainRoute === route
                ? "urlContainer selected text-primary flex justify-between font-bold w-full"
                : "urlContainer flex justify-between w-full"}
            {...$$restProps}
            on:mouseenter={handleMouseEnter}
            on:mouseleave={handleMouseLeave}
        >
            <div class="flex items-center w-full">
                <div class="flex items-center gap-x-2 w-full">
                    <div class="w-[25px]">
                        <i
                            class={`${iFont} text-[#6f726C]`}
                            style={`font-size:${
                                sidebarExpanded ? "18px" : "15px"
                            }`}
                        />
                    </div>

                    {#if sidebarExpanded}
                        <div class="flex w-full items-center">
                            <p class="text-[#6f726C]">
                                {title}
                            </p>
                        </div>

                        <i style="font-size: 15px" />
                    {:else}
                        <div class="flex items-center">
                            <i style="font-size: 8px" />
                        </div>
                    {/if}
                </div>
            </div>
        </div>
    {:else}
        <div class="hidden" />
    {/if}
</li>

<style>
    div {
        transition: 0.2s ease-in;
    }

    .urlContainer,
    .display {
        font-size: 16px;
        line-height: 24px;
        color: #5229d2;
        padding: 10px 16px 10px 8px;
    }

    li > .selected,
    li:hover > .urlContainer,
    li:hover > .display {
        border: 0 solid rgba(0, 0, 0, 0.02);
        border-radius: 0px 50px 50px 0px;
        background: linear-gradient(
            270deg,
            rgba(39, 0, 83, 0.2397) 16.85%,
            rgba(39, 0, 83, 0.0893) 71.98%
        );
    }

    p {
        font-size: 15px;
        line-height: 18px;
    }
</style>
